export default __webpack_public_path__ + "assets/models/de9df6975716e7aaedf4e9643c2ac7dd.glb";